export const Status = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '14',
  '15',
  '90',
  '91',
  '99'
];
export const RequestType = ['0', '1'];
export const SharepointDomain = 'https://cmhcschl.sharepoint.com/sites/HomeownerPortfolio';
export const PrefixFieldFolder = encodeURIComponent('EPIP Pools DEV');
export const Success = 'Successful';
export const UnSuccess = 'Unsuccessful';
export const premiumDiscountOption = ['yes', 'no'];
export const fraudDetectionIndicatorOption = ['yes', 'no'];
export const OTHER_REMARK_CODE = 9999;
// POOL_SUBMISSION_PACKAGE_CODES can be from 8000 to 8999
export const POOL_SUBMISSION_PACKAGE_CODES = Array.from({ length: 1000 }, (_, i) => 8000 + i);
// OFFER_EMAIL_CODES can be from 9000 to 9998
export const OFFER_EMAIL_CODES = Array.from({ length: 999 }, (_, i) => 9000 + i);
// REASON_FOR_WITHDRAWAL can be from 4000 to 4999
export const REASON_FOR_WITHDRAWAL = Array.from({ length: 1000 }, (_, i) => 4000 + i);
// REASON_FOR_PASSING_LOAN_NON_CANCELLATION can be from 1 to 999
export const REASON_FOR_PASSING_LOAN_NON_CANCELLATION = Array.from(
  { length: 999 },
  (_, i) => 1 + i
);
// REASON_FOR_FAILING_LOAN_NON_CANCELLATION can be from 1000 to 1999
export const REASON_FOR_FAILING_LOAN_NON_CANCELLATION = Array.from(
  { length: 1000 },
  (_, i) => 1000 + i
);
// REASON_FOR_PASSING_LOAN_CANCELLATION can be from 2000 to 2999
export const REASON_FOR_PASSING_LOAN_CANCELLATION = Array.from(
  { length: 1000 },
  (_, i) => 2000 + i
);
// REASON_FOR_FAILING_LOAN_CANCELLATION can be from 3000 to 3999
export const REASON_FOR_FAILING_LOAN_CANCELLATION = Array.from(
  { length: 1000 },
  (_, i) => 3000 + i
);
export const CODES_FOR_REMARK_REVIEWR_MESSAGE = [9999, 9998, 8999];
export const OTHER_REMARK_CODES = [9998];
// dropdownIdsWithdrawnStatus can be from 5000 to 5999 and add 9999
export const dropdownIdsWithdrawnStatus = Array.from({ length: 1000 }, (_, i) => 5000 + i).concat(
  9999
);
// dropdownIdsApprovedStatus can be from 6000 to 6999 and add 9999
export const dropdownIdsApprovedStatus = Array.from({ length: 1000 }, (_, i) => 6000 + i).concat(
  9999
);
